import { Box, Skeleton } from '@mui/material';
import React from 'react';

function MemoryQACardSkeleton() {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      borderRadius='10px'
      width='100%'
    >
      <Skeleton
        variant='text'
        sx={{
          fontSize: '1.3rem',
          borderRadius: '10px',
          padding: 1,
        }}
        width='95%'
      />
      <Skeleton
        variant='text'
        sx={{
          fontSize: '1.3rem',
          borderRadius: '10px',
          padding: 1,
        }}
        width='95%'
      />
      <Skeleton
        variant='text'
        sx={{
          fontSize: '1.3rem',
          borderRadius: '10px',
          padding: 1,
        }}
        width='95%'
      />
      <Skeleton
        variant='text'
        sx={{
          fontSize: '1.3rem',
          borderRadius: '10px',
          padding: 1,
        }}
        width='95%'
      />
    </Box>
  );
}

export default MemoryQACardSkeleton;
